import React, { useEffect, useState } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import blogFetch from "../../axios/config";
import { FormatDate } from "../../utils/DataUtils";
import { Button, Form, InputGroup } from "react-bootstrap";
import { LoadSpinner } from "../../componentes/atoms/LoadSpinner";
import Loading from "../../components/Loading";


export const RastrearPecas = ({ }) => {

    const [pieces, setPieces] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPieces();
    }, []);

    const getPieces = async () => {
        try {
            setLoading(true);
            const { data } = await blogFetch.get("/ISAGA_VagoesFornosPecas/historicPieces")

            setPieces(data);
            return data;
        } catch {
            console.error("Error")
        }
        finally {
            setLoading(false)
        }
    };


    const [searchPieces, setSearchPices] = useState("");

    const filteredParts = pieces.filter(
        ({ ordem_Serial, vagoes_Fornos }) =>
            ordem_Serial.toString().toLowerCase().includes(searchPieces.toLowerCase()) ||
            vagoes_Fornos.vagao_Serial.toString().toLowerCase().includes(searchPieces.toLowerCase())
    );


    return (
        <>
            <Navbar />
            <Sidebar />
            <div className="app_body " >

                <div className="" style={{ maxHeight: '800px', overflowY: 'auto' }}>
                    <InputGroup>
                        <Form.Control
                            placeholder="Buscar Vagão ou ordem Serial"
                            value={searchPieces}
                            onChange={({ target }) => setSearchPices(target.value)}
                        />
                        <Button className="status-molde-button-form">
                            Buscar
                        </Button>
                    </InputGroup>
                    {loading ? <Loading /> : (
                        <div className="overflow-x-auto w-full m-1">
                            <table className="min-w-full table border-r-0 border-gray-300 rounded-lg shadow-sm" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead className="bg-gray-100 text-gray-700 sticky top-0 z-10">
                                    <tr>
                                        <th className="px-4 py-2 border-b">VAGÃO SERIAL</th>
                                        <th className="px-4 py-2 border-b">ORDEM SERIAL</th>
                                        <th className="px-4 py-2 border-b">STATUS PEÇA</th>
                                        <th className="px-4 py-2 border-b">CANCELADO POR</th>
                                        <th className="px-4 py-2 border-b">DATA CANCELADO</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center text-sm text-gray-800">
                                    {filteredParts.map((item, index) => (
                                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                            <td className="px-4 py-2 border-b">{item.vagoes_Fornos.vagao_Serial}</td>
                                            <td className="px-4 py-2 border-b">{item.ordem_Serial}</td>
                                            <td className="px-4 py-2 border-b">{item.status_Peca}</td>
                                            <td className="px-4 py-2 border-b">{item.vagoes_Fornos._Mod_Cancelado}</td>
                                            <td className="px-4 py-2 border-b">{FormatDate(item.vagoes_Fornos._ts_Mod_Cancelado)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}


                </div>

            </div>
        </>
    );
}